<template>
    <b-container fluid>

      
  <PortalNavbar show="true"></PortalNavbar>
<section class="download_area row" style="margin-left:40px;">
<div class="container">
<!--<div class="tittle wow fadeInUp">
                <h2>DOWNLOAD</h2>
               
            </div>-->
<div class="row download_row">
<div class="col-md-10">
<div class="subtittle">
                        <h2 style="color:#ec5624;">DOWNLOAD</h2>
                    </div>

<table width="110%" style="margin-top:60px;">
<tbody>
<tr>
<th style="width:60%; height:45px; text-align:center; background-color:blue; color:white;">Name of the Form / Document / Information</th>
<th width="10%" style="text-align:center; background-color:blue; color:white;">Download</th>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;The Maharashtra Private Security Guards ( Regulation of Employment and Welfare ) ACT 1981</td>
<td align="left"><a href="@/assets/pdf/MPSGACT.pdf"><img src="">&nbsp;&nbsp;Download 1</a><br>
<a href="pdf/mpsgact34-47.pdf"><img src="">&nbsp;&nbsp;Download 2</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Wages circular of security guards</td>
<td align="left"><a href="pdf/WAGESCIRCULARJUL18.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;TDS Certificate 2018-19</td>
<td align="left"><a href="pdf/tds-certificate-18-19.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;English Wages Circular Of Jan 2018 To 30 Jun 2018</td>
<td align="left"><a href="pdf/daincreasesenglish.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Marathi Wages Circular Of Jan 2018 To 30 Jun 2018</td>
<td align="left"><a href="pdf/daincreasesmarathi.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Appointment of Technical Consultant</td>
<td align="left"><a href="pdf/technicalconsultant.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;PF Slip 2016-2017</td>
<td align="left"><a href="pdf/jan2018notice.jpg"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Notice and Circular of D.A.</td>
<td align="left"><a href="pdf/NoticeandCircularofDA.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Notice Of PF Department</td>
<td align="left"><a href="pdf/notice.jpg"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Important Notice to Registered Principal Employers</td>
<td align="left"><a href="pdf/impnotice.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Maharashtra State Government Orders</td>
<td align="left"><a href="pdf/govt.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;General Circular</td>
<td align="left"><a href="pdf/doc1.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Revision of Wages & Allowances</td>
<td align="left"><a href="pdf/Wages.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Application Form for Registration of Principal Employer (FORM-'A')</td>
<td align="left"><a href="pdf/21_11forma.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Application Form for Registration of Exempted Security Agency (FORM 'A-1')</td>
<td align="left"><a href="pdf/21_11forma1.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Application Form for Registration of Principle Employer of Exempted Security Guards (Form 'A-A')</td>
<td align="left"><a href="pdf/21_11forma-a.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;List of Registered Principle Employers of the Board as on 22/04/2016</td>
<td align="left"><a href="pdf/employers.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;TDS Exemption Certificate</td>
<td align="left"><a href="pdf/tds1617.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Note regarding Non Applicability of Service Tax</td>
<td align="left"><a href="pdf/service-tax.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Recruitment GR-2 March 2009</td>
<td align="left"><a href="pdf/RecruitmentGR-2March2009.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Recruitment GR-17 oct 2013</td>
<td align="left"><a href="pdf/RecruitmentGR-17oct2013.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Recruitment GR-25 Aug 2010</td>
<td align="left"><a href="pdf/RecruitmentGR-25Aug2010.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Recruitment GR-Anukampa-15 July 2009</td>
<td align="left"><a href="pdf/RecruitmentGR-Anukampa-15July2009.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Private Security Guards (Regulation Of Employment And welfare )scheme 2002</td>
<td align="left"><a href="pdf/PRIVATESECURITYGUARDS(REGULATIONOFEMPLOYMENTANDWELFARE)SCHEME2002.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Private Security Guards (Regulation Of Employment And welfare )ACT 2005</td>
<td align="left"><a href="pdf/private_security_agencies_regulation_act_2005.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;The Maharashtra Private Security Guards (Regulation Of Employment And welfare )Rules 2007</td>
<td align="left"><a href="pdf/private_security_agencies_regulation_rules_2007.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;ESIC Circular letter AUG 2016</td>
<td align="left"><a href="pdf/ESIC_Circular_letter_29_AUG_2016.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;General Instructions Security Staff</td>
<td align="left"><a href="pdf/OFFICE_ORDER_FOR_THE_SECURITY_STAFF.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Bonus Notice</td>
<td align="left"><a href="pdf/5_10_2017_letter.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

<tr>
<td align="left">&nbsp;&nbsp;Nagrik Sanad</td>
<td align="left"><a href="pdf/nagriksanad.pdf"><img src="">&nbsp;&nbsp;Download</a></td>
</tr>

</tbody>
</table>



</div>
</div>
</div>
</section>
   
    </b-container>
</template>

<script>
import PortalNavbar from "@/components/PortalNavbar";
export default {
components: { PortalNavbar}
}
</script>

<style scoped>


.download_area .download_row {
  padding-top: 70px;
  padding-bottom: 70px;
}
.subtittle h2 {
  font: 700 36px "Open sans", sans-serif;
  color: #222222;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 20px;
}
.subtittle h2:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 80px;
  background: #222222;
  left: 0;
  bottom: -22px;
}

table,th,td{
border:1px solid black;

margin-left:40px;
}


tbody{
font: 400 14px/26px "Open sans", sans-serif;
  color: #555555;
 padding-top: 28px;
  padding-bottom: 54px;
outline-style:double;
}


</style>



// WEBPACK FOOTER //
// src/components/Portal/Download.vue